import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS,PrivacyPolicySettings} from '@chekin/core';
import {API} from '@chekin/api';
import {getDocumentDownloadByLanguage} from '../utils/common';

type Props = {
  housingId: string | undefined;
};

function useFetchPrivacyPolicySettings({housingId}: Props) {
  const {i18n} = useTranslation();

  const {data: privacyPolicySettings, isLoading} = useQuery<PrivacyPolicySettings>({
    queryKey: [QUERY_CACHE_KEYS.privacyPolicySettings, housingId],
    queryFn: () => API.documents.getPrivacyPolicy(housingId || ''),
    enabled: !!housingId,
    refetchOnWindowFocus: false,
  });

  const hasCustomPrivacyPolicy = Boolean(
    privacyPolicySettings?.has_custom_privacy_policy,
  );

  const documentDownload = useMemo(() => {
    if (privacyPolicySettings) {
      return getDocumentDownloadByLanguage(privacyPolicySettings, i18n.language);
    }

    return '';
  }, [i18n.language, privacyPolicySettings]);

  return {
    privacyPolicySettings,
    isLoading,
    hasCustomPrivacyPolicy,
    documentDownload,
  };
}

export {useFetchPrivacyPolicySettings};
